(() => {
  if (window.dawnColorMediaLoaded) return;
  window.dawnColorMediaLoaded = true;
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase();
  customElements.whenDefined('media-gallery').then(() => {
    const Gallery = customElements.get('media-gallery');
    const original = Gallery.prototype.setActiveMedia;
    function config(gallery) {
      const node = gallery.querySelector('[data-color-media-config]');
      if (!node) return null;
      if (!gallery.colorMediaConfig) gallery.colorMediaConfig = JSON.parse(node.textContent);
      return gallery.colorMediaConfig;
    }
    function currentColor(gallery, data, mediaId) {
      const picker = Array.from(document.querySelectorAll('variant-selects, variant-radios')).find(el => el.dataset.section === data.section);
      if (picker?.currentVariant) return picker.currentVariant.options[data.option];
      const groups = picker ? Array.from(picker.querySelectorAll('select, fieldset')) : [];
      const group = groups[data.option];
      if (group) return group.tagName === 'SELECT' ? group.value : group.querySelector('input:checked')?.value;
      const variant = data.variants.find(v => `${data.section}-${v.media}` === mediaId);
      return variant ? variant.color : data.selected;
    }
    function apply(gallery, color) {
      const data = config(gallery);
      if (!data || !color) return null;
      const key = normalize(color);
      // A missing/misspelled group must never leave the customer with an empty gallery.
      const hasGroup = data.media.some(m => normalize(m.color) === key && m.color);
      const visible = new Set(data.media.filter(m => !hasGroup || !m.color || normalize(m.color) === key).map(m => String(m.id)));
      const slides = Array.from(gallery.elements.viewer.querySelectorAll('[data-media-id]'));
      slides.forEach(slide => {
        const id = slide.dataset.mediaId.slice(data.section.length + 1);
        slide.classList.toggle('color-media-hidden', !visible.has(id));
        if (!visible.has(id)) slide.classList.remove('is-active');
      });
      gallery.elements.thumbnails?.querySelectorAll('[data-target]').forEach(thumb => {
        const id = thumb.dataset.target.slice(data.section.length + 1);
        thumb.classList.toggle('color-media-hidden', !visible.has(id));
      });
      const modal = document.getElementById(`ProductModal-${data.section}`);
      modal?.querySelectorAll('[data-media-id]').forEach(item => {
        item.classList.toggle('color-media-hidden', !visible.has(String(item.dataset.mediaId)));
      });
      gallery.colorMediaKey = key;
      return slides.filter(slide => !slide.classList.contains('color-media-hidden'));
    }
    function refresh(gallery) {
      [gallery.elements.viewer, gallery.elements.thumbnails].filter(Boolean).forEach(slider => {
        if (!slider.slider || !slider.nextButton) return;
        slider.resetPages();
        const items = Array.from(slider.sliderItems).filter(item => item.clientWidth > 0);
        if (items.length < 2) {
          slider.sliderItemOffset = Math.max(1, items[0]?.clientWidth || 1);
          slider.slidesPerPage = 1;
          slider.totalPages = items.length;
          slider.currentPage = 1;
          if (slider.currentPageElement) slider.currentPageElement.textContent = items.length ? '1' : '0';
          if (slider.pageTotalElement) slider.pageTotalElement.textContent = String(items.length);
          slider.prevButton?.setAttribute('disabled', 'disabled');
          slider.nextButton.setAttribute('disabled', 'disabled');
        }
      });
    }
    Gallery.prototype.setActiveMedia = function(mediaId, prepend) {
      const data = config(this);
      if (!data) return original.call(this, mediaId, prepend);
      const color = currentColor(this, data, mediaId);
      const sameColor = this.colorMediaKey === normalize(color);
      const slides = apply(this, color);
      if (!slides?.length) return original.call(this, mediaId, prepend);
      const active = slides.find(slide => slide.classList.contains('is-active'));
      // A size change keeps the current photograph; thumbnail clicks still navigate.
      if (prepend && sameColor && active) { refresh(this); return; }
      const target = slides.find(slide => slide.dataset.mediaId === mediaId) || slides[0];
      original.call(this, target.dataset.mediaId, false);
      refresh(this);
    };
    window.dawnColorMediaReady = true;
    function init(root = document) {
      root.querySelectorAll('media-gallery').forEach(gallery => {
        const data = config(gallery);
        if (!data || gallery.colorMediaInitialized) return;
        gallery.colorMediaInitialized = true;
        const active = gallery.querySelector('[data-media-id].is-active') || gallery.querySelector('[data-media-id]');
        if (active) gallery.setActiveMedia(active.dataset.mediaId, true);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
    else init();
    document.addEventListener('shopify:section:load', event => init(event.target));
  });
})();